import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state/index";
import { Pagination } from "antd";
import { serverAddress } from "../../constant";
import TableSkeleton from "../skeletons/TableSkeleton";

const exportToCSV = (rows) => {
  const headers = [
    "S.No.", "First Name", "Last Name", "Email", "Mobile",
    "Designation", "Institute", "Institute Address", "University",
    "District", "State", "Country", "Nationality", "Postal Address",
    "Category", "Paper Title", "Payment Status", "Amount", "Created At",
  ];

  const escape = (val) => {
    if (val == null) return "";
    const str = String(val).replace(/"/g, '""');
    return str.includes(",") || str.includes("\n") || str.includes('"') ? `"${str}"` : str;
  };

  const csvRows = rows.map((item, index) => [
    index + 1,
    item.firstName,
    item.lastName,
    item.email,
    item.mobile,
    item.designation,
    item.institute,
    item.instituteAddress,
    item.university,
    item.district,
    item.state,
    item.country,
    item.nationality,
    item.postalAddress,
    item.category,
    item.paperTitle,
    item.paymentStatus,
    item.amount,
    item.createdAt?.slice(0, 10),
  ].map(escape).join(","));

  const csv = [headers.join(","), ...csvRows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "international_law_seminar.csv";
  link.click();
  URL.revokeObjectURL(url);
};

const API_URL = `${serverAddress}/law-conference-2025/get/all`;

const LawSeminarInternationalTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { top_loader } = bindActionCreators(actionCreators, dispatch);
  const [allData, setAllData] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [recperpage, SetRecPerPage] = useState(10);
  const [activepage, SetActivePage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [paymentFilter, setPaymentFilter] = useState("All");

  const handleRowClick = (student) => {
    navigate(`/dashboard/international-law-seminar/${student._id}`);
  };

  useEffect(() => {
    top_loader(true, 45);
    getAll();
  }, []);

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .custom-sidebar::-webkit-scrollbar { display: none; }
      .custom-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const getAll = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}?page=1&limit=10000&sortBy=createdAt&sortOrder=desc`);
      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        setAllData(result.data);
      } else {
        setAllData([]);
      }
    } catch (err) {
      setAllData([]);
    } finally {
      setLoading(false);
      top_loader(true, 100);
      top_loader(false, 0);
    }
  };

  const filteredData = allData.filter((item) => {
    const q = searchText.toLowerCase();
    const matchesSearch =
      !q ||
      (item.fullName || `${item.firstName || ""} ${item.lastName || ""}`)
        .toLowerCase()
        .includes(q) ||
      (item.email || "").toLowerCase().includes(q) ||
      (item.mobile || "").toLowerCase().includes(q);

    const matchesPayment =
      paymentFilter === "All" ||
      (paymentFilter === "Paid" && item.paymentStatus === "Paid") ||
      (paymentFilter === "Pending" && item.paymentStatus !== "Paid");

    return matchesSearch && matchesPayment;
  });

  const totalData = filteredData.length;
  const startIndex = (activepage - 1) * recperpage;
  const pageData = filteredData.slice(startIndex, startIndex + recperpage);

  function handlePageChange(page) {
    SetActivePage(page);
  }

  function applyFilter(event) {
    const newLimit = Number(event.target.value);
    SetRecPerPage(newLimit);
    SetActivePage(1);
  }

  const handleExport = () => {
    exportToCSV(filteredData);
  };

  return (
    <Container
      fluid
      className="p-0 custom-sidebar"
      style={{
        backgroundColor: "#F2F5F7",
        fontFamily: "Inter",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <Row style={{ marginInline: "10px" }}>
        <Col lg={12}>
          <div className="py-2" style={{ marginTop: "80px" }}>
            <div className="d-flex justify-content-between align-items-center mb-2 gap-2">
              <div className="d-flex gap-2 align-items-center">
                <input
                  type="text"
                  placeholder="Search by name, email, mobile..."
                  value={searchText}
                  onChange={(e) => { setSearchText(e.target.value); SetActivePage(1); }}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontFamily: "Inter",
                    width: "280px",
                  }}
                />
                <Form.Select
                  value={paymentFilter}
                  onChange={(e) => { setPaymentFilter(e.target.value); SetActivePage(1); }}
                  style={{ width: "160px", border: "1px solid #ccc", borderRadius: "6px", fontFamily: "Inter" }}
                >
                  <option value="All">All Payments</option>
                  <option value="Paid">Paid</option>
                  <option value="Pending">Pending</option>
                </Form.Select>
              </div>
              <button
                onClick={handleExport}
                style={{
                  backgroundColor: "#663399",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "6px 18px",
                  fontFamily: "Inter",
                  cursor: "pointer",
                }}
              >
                Export CSV
              </button>
            </div>
            <div
              className="maintable"
              id="table-container"
              style={{ height: "auto", width: "auto" }}
            >
              {loading ? (
                <TableSkeleton />
              ) : (
                <table className="col-md-12 enquiryTable px-3">
                  <thead className="bg-transparent ">
                    <tr className="tableHeading tableHeadAllEnquiry bg-transparent">
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>

                      <th>Category Name</th>
                      <th>Amount</th>
                      <th style={{ width: "10%" }}>Payment Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {pageData.length > 0 ? (
                      pageData.map((item, index) => (
                        <tr
                          key={item._id}
                          className="tableRows"
                          onClick={() => handleRowClick(item)}
                        >
                          <td>{startIndex + index + 1}</td>
                          <td style={{ width: "15%" }}>{item.fullName}</td>
                          <td style={{ width: "15%" }}>{item.email}</td>
                          <td>{item.mobile}</td>
                          {/* <td>{item.designation}</td> */}
                          <td>{item.category}</td>
                          <td>{item.amount}</td>
                          <td>
                            {item.paymentStatus === "Paid" ? (
                              <span
                                style={{
                                  border: "1px solid #CAEEDB",
                                  backgroundColor: "#CAEEDB",
                                  color: "#46CF85",
                                  padding: "3px 5px",
                                  borderRadius: "4px",
                                }}
                              >
                                Payment Done
                              </span>
                            ) : (
                              <span
                                style={{
                                  border: "1px solid #FFE3E0",
                                  backgroundColor: "#FFE3E0",
                                  color: "#F7685B",
                                  padding: "3px 13px",
                                  borderRadius: "4px",
                                }}
                              >
                                {item.paymentStatus || "Pending"}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center" }}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>

            <div className="col-md-12 form-inline py-2 tableFooter d-flex gap-5 align-items-center">
              <div className="col-md-4 d-flex gap-2 align-baseline">
                <label
                  className="control-label col-md-4"
                  style={{
                    fontWeight: "700",
                    paddingTop: "5px",
                    paddingLeft: "25px",
                  }}
                >
                  Rows per page :
                </label>
                <Form.Select
                  className="form-control "
                  onChange={(event) => applyFilter(event)}
                  value={recperpage}
                  style={{
                    border: "solid",
                    borderWidth: "thin",
                    color: "#000",
                  }}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </Form.Select>
              </div>

              <div
                className="col-md-8 d-flex gap-2"
                style={{
                  justifyContent: "end",
                  alignItems: "center",
                  paddingRight: "60px",
                }}
              >
                <Pagination
                  total={totalData}
                  showSizeChanger={false}
                  current={activepage}
                  size="small"
                  pageSize={recperpage}
                  onChange={(page, pageSize) => {
                    handlePageChange(page);
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LawSeminarInternationalTable;
